module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loginbox"
  }, [_c('div', {
    staticClass: "login"
  }, [_c('div', {
    staticClass: "logo-group"
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-box border"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.mp),
      expression: "mp",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "tel",
    attrs: {
      "type": "tel",
      "placeholder": "手机号",
      "maxlength": "11"
    },
    domProps: {
      "value": (_vm.mp)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.mp = $event.target.value.trim()
      }, _vm.onlyNum],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (_vm.countDown) ? _c('span', {
    staticClass: "get-code"
  }, [_vm._v(_vm._s(_vm.time) + "s")]) : _c('span', {
    staticClass: "get-code",
    on: {
      "click": _vm.postSmsCaptcha
    }
  }, [_vm._v("获取验证码")])]), _vm._v(" "), _c('div', {
    staticClass: "input-box border"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.captcha),
      expression: "captcha",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "number",
      "placeholder": "验证码",
      "maxlength": "6",
      "oninput": "if(value.length>6) value = value.slice(0,6)"
    },
    domProps: {
      "value": (_vm.captcha)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.captcha = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "tips"
  }, [_vm._v("如果您还没有用这个手机号注册过俺来也，我们将为您创建俺来也账号。")]), _vm._v(" "), _c('span', {
    staticClass: "btn btn-main btn-lg btn-block",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.postSignIn.apply(null, arguments)
      }
    }
  }, [_vm._v("登 录")])]), _vm._v(" "), (_vm.showDrag) ? _c('div', {
    staticClass: "mask",
    staticStyle: {
      "z-index": "105"
    }
  }, [_c('div', {
    staticClass: "drag"
  }, [_c('div', {
    staticClass: "close-btn",
    on: {
      "click": function($event) {
        _vm.showDrag = false
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h3', [_vm._v("请您通过验证")]), _vm._v(" "), _c('div', {
    staticClass: "drag_box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "handler_bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "handler",
    on: {
      "touchstart": function($event) {
        return _vm.mouseDownFn($event)
      }
    }
  })]), _vm._v(" "), _c('p', [_vm._v("向右滑吃掉豆子~")])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "drag_bg"
  }, [_c('li'), _vm._v(" "), _c('li'), _vm._v(" "), _c('li'), _vm._v(" "), _c('li'), _vm._v(" "), _c('li'), _vm._v(" "), _c('li')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-8912eb0a","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/pages/Login.vue
// module id = 454
// module chunks = 7